import { ITheme } from '@fluentui/react/lib/Styling';
import { ICustomizations } from '@fluentui/react/lib/Utilities';
import { backgroundNames, ThemeNames } from './teams-theme-types';
import { getTeamStyles } from './teams/teams-styles';
import {
  TeamsThemeContrast,
  TeamsThemeDark,
  TeamsThemeDefault
} from './teams/teams-theme';

const map: Record<string, ICustomizations> = {};

export const getPalette = (themeName: ThemeNames): ITheme => {
  switch (themeName) {
    case 'dark':
      return TeamsThemeDark;
    case 'contrast':
      return TeamsThemeContrast;
    default:
      return TeamsThemeDefault;
  }
};

export const getTeamsTheme = (
  themeName: ThemeNames,
  background?: backgroundNames
): ICustomizations => {
  const themeKey = background ? themeName + background : themeName;

  if (map[themeKey]) {
    return map[themeKey];
  }
  const palette = getPalette(themeName);
  const customizations = {
    settings: {
      theme: palette
    },
    scopedSettings: getTeamStyles(themeName, palette, background)
  };

  map[themeKey] = customizations;
  return customizations;
};
